import axios from "axios";

const apiClient = axios.create({
  baseURL: "/wp-json",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  getRelated(args = {}) {
    return apiClient.get("/zarts/v1/related", args);
  },
  getSettings(args = {}) {
    return apiClient.get("/zarts/v1/feed-settings", args);
  },
};
